import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-2 umt-form" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom border-gray-200" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs-4 umt-drawer-title text-gray-900",
  style: {"font-weight":"700"}
}, "Cập nhật điểm hồ sơ trúng tuyển", -1)
const _hoisted_4 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border text-primary" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "fs-5 fw-bold text-gray-900" }
const _hoisted_10 = { class: "text-muted fs-7" }
const _hoisted_11 = { class: "fw-semibold text-gray-700" }
const _hoisted_12 = { class: "fw-semibold text-gray-700" }
const _hoisted_13 = { class: "fw-semibold text-gray-700" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "fw-semibold text-gray-700" }
const _hoisted_16 = { class: "alert alert-warning d-flex align-items-start py-3 px-4 mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning fs-4 me-3 mt-1" }, null, -1)
const _hoisted_18 = { class: "fs-8 text-gray-800" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("b", null, "cả điểm gốc của ứng viên", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("b", null, "mọi nguyện vọng", -1)
const _hoisted_21 = {
  key: 0,
  class: "text-danger fw-semibold d-block mt-1"
}
const _hoisted_22 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_23 = {
  class: "text-gray-800 mb-1 d-flex align-items-center justify-content-between",
  style: {"font-weight":"700"}
}
const _hoisted_24 = {
  key: 0,
  class: "text-muted fs-9 mb-3"
}
const _hoisted_25 = {
  key: 1,
  class: "text-muted fs-9 mb-3"
}
const _hoisted_26 = { class: "col-3 fs-7 fw-semibold text-gray-800" }
const _hoisted_27 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_28 = {
  key: 1,
  class: "col-4"
}
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = {
  key: 2,
  class: "col-12 fs-9 text-warning mt-0"
}
const _hoisted_31 = { class: "d-flex align-items-center mb-2" }
const _hoisted_32 = { class: "fs-7 text-gray-800" }
const _hoisted_33 = {
  key: 0,
  class: "text-muted fs-9"
}
const _hoisted_34 = { class: "fs-8 text-gray-700" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1)
const _hoisted_36 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-800 mb-1 required" }, "Lý do thu hồi QĐ trúng tuyển", -1)
const _hoisted_38 = {
  key: 1,
  class: "fs-8 text-danger fw-semibold"
}
const _hoisted_39 = {
  class: "d-flex justify-content-end align-items-center py-3 border-top border-gray-200",
  style: {"position":"sticky","bottom":"0","z-index":"2","background":"var(--bs-body-bg, #fff)"}
}
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.show) = $event)),
    direction: "rtl",
    size: "560px",
    "with-header": false,
    "append-to-body": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", {
            class: "btn btn-sm btn-icon btn-active-light-primary flex-shrink-0",
            title: "Đóng",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false))
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_ctx.sheet)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.sheet.winner.fullName || '—'), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createTextVNode(" Mã HS: "),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.sheet.winner.profileCode), 1),
                    _createTextVNode(" · NV" + _toDisplayString(_ctx.sheet.winner.nv) + " ", 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.sheet.winner.adMajor), 1),
                    _createTextVNode(" · Tổ hợp "),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.sheet.winner.adForm), 1),
                    (_ctx.sheet.winner.decisionCode)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _createTextVNode(" · QĐ "),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.sheet.winner.decisionCode), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createTextVNode(" Lưu sẽ sửa "),
                    _hoisted_19,
                    _createTextVNode(" (" + _toDisplayString(_ctx.sheet.method === 1 ? 'bảng điểm học bạ' : 'điểm thi TN THPT') + ") và điểm của ", 1),
                    _hoisted_20,
                    _createTextVNode(" trong hồ sơ có môn này, kèm tính lại tổng điểm xét. Dấu ✓ khớp Bộ (nếu có) sẽ bị gỡ — import lại file Bộ để xác thực lại. "),
                    (_ctx.sheet.winner.synchronized)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Hồ sơ ĐÃ đồng bộ SIS — điểm trên SIS phải chỉnh thủ công."))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", null, "Điểm 3 môn tổ hợp " + _toDisplayString(_ctx.sheet.winner.adForm), 1),
                    (_ctx.sheet.subjects.some(s => s.baseDiff))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "fs-8 fw-bold text-primary cursor-pointer text-decoration-underline",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fillFromBase()))
                        }, "Lấy theo điểm gốc ứng viên"))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.sheet.method === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Điểm học bạ từng lớp 10 / 11 / 12 (thang 10)."))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, "Điểm thi TN THPT từng môn (thang 10).")),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sheet.subjects, (s) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: s.key,
                      class: "row g-2 align-items-center mb-2"
                    }, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(s.label), 1),
                      (_ctx.sheet.method === 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(['c10', 'c11', 'c12'], (k) => {
                            return _createElementVNode("div", {
                              class: "col-3",
                              key: k
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                step: "0.1",
                                min: "0",
                                max: "10",
                                class: "form-control form-control-sm",
                                placeholder: 'Lớp ' + k.slice(1),
                                "onUpdate:modelValue": ($event: any) => ((_ctx.vals[s.key][k]) = $event),
                                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.review = null))
                              }, null, 40, _hoisted_27), [
                                [_vModelText, _ctx.vals[s.key][k]]
                              ])
                            ])
                          }), 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              step: "0.01",
                              min: "0",
                              max: "10",
                              class: "form-control form-control-sm",
                              placeholder: "Điểm thi",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.vals[s.key].score) = $event),
                              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.review = null))
                            }, null, 40, _hoisted_29), [
                              [_vModelText, _ctx.vals[s.key].score]
                            ])
                          ])),
                      (s.baseDiff)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Điểm gốc ứng viên: " + _toDisplayString(_ctx.sheet.method === 1 ? [s.base.c10, s.base.c11, s.base.c12].map(v => (v === null || v === undefined || v === '') ? '—' : v).join(' / ') : ((s.base.score === null || s.base.score === undefined) ? '—' : s.base.score)) + " (đang KHÁC điểm hồ sơ) ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                (_ctx.review)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["border rounded p-4 mb-4", _ctx.review.passed === true ? 'border-success bg-light-success' : (_ctx.review.passed === false ? 'border-danger bg-light-danger' : 'border-warning bg-light-warning')])
                    }, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge fs-7 py-2 px-3 me-3", _ctx.review.passed === true ? 'badge-success' : (_ctx.review.passed === false ? 'badge-danger' : 'badge-warning')])
                        }, _toDisplayString(_ctx.review.passed === true ? 'VẪN ĐẠT điểm chuẩn' : (_ctx.review.passed === false ? 'KHÔNG ĐẠT điểm chuẩn' : 'KHÔNG XÁC ĐỊNH ĐƯỢC')), 3),
                        _createElementVNode("span", _hoisted_32, [
                          _createTextVNode(" Tổng điểm xét: "),
                          _createElementVNode("b", null, _toDisplayString(_ctx.review.old.avg), 1),
                          _createTextVNode(" → "),
                          _createElementVNode("b", null, _toDisplayString(_ctx.review.next.avg), 1),
                          (_ctx.review.benchmark.value !== null)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · Điểm chuẩn: "),
                                _createElementVNode("b", null, _toDisplayString(_ctx.review.benchmark.value), 1),
                                (_ctx.review.benchmark.year)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, " (" + _toDisplayString(_ctx.review.benchmark.year) + ")", 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, "Điểm 3 môn (chưa ưu tiên): " + _toDisplayString(_ctx.review.next.adm) + " · Ưu tiên tạm tính: " + _toDisplayString(_ctx.review.next.pNew), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.review.notes, (n, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "fs-8 text-gray-800 mt-1"
                        }, [
                          _hoisted_35,
                          _createTextVNode(_toDisplayString(n), 1)
                        ]))
                      }), 128)),
                      (_ctx.review.passed === false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            (_ctx.review.revocable)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_37,
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "form-control form-control-sm",
                                    rows: "2",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reason) = $event)),
                                    placeholder: "vd: điểm hồ sơ lệch với dữ liệu Bộ GD&ĐT, sau cập nhật không đạt điểm chuẩn"
                                  }, null, 512), [
                                    [_vModelText, _ctx.reason]
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock("div", _hoisted_38, "Hồ sơ trúng TẠM (chưa có QĐ) — dùng nút \"Xét tuyển lại\" ở màn chốt trúng tuyển thay vì thu hồi."))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("span", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.show = false)),
                    class: "btn btn-white btn-active-light-primary me-2 umt-btn-32"
                  }, _toDisplayString(_ctx.review && _ctx.review.passed === false ? 'Quay lại' : 'Hủy bỏ'), 1),
                  (!_ctx.review)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary umt-btn-32",
                        disabled: _ctx.checking,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.runReview()))
                      }, [
                        (_ctx.checking)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41))
                          : _createCommentVNode("", true),
                        _createTextVNode("Xét tuyển lại ")
                      ], 8, _hoisted_40))
                    : (_ctx.review.passed !== false)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: _normalizeClass(["btn umt-btn-32", _ctx.review.passed === true ? 'btn-primary' : 'btn-warning']),
                          disabled: _ctx.applying,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.runApply()))
                        }, [
                          (_ctx.applying)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43))
                            : _createCommentVNode("", true),
                          _createTextVNode("Cập nhật điểm ")
                        ], 10, _hoisted_42))
                      : (_ctx.review.revocable)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "btn btn-danger umt-btn-32",
                            disabled: _ctx.applying || !_ctx.reason.trim(),
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.runApply()))
                          }, [
                            (_ctx.applying)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_45))
                              : _createCommentVNode("", true),
                            _createTextVNode("Cập nhật & Thu hồi QĐ ")
                          ], 8, _hoisted_44))
                        : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}